module.exports = __webpack_public_path__ + "img/bp_kuang.ebd5b219.png";